<template>
  <div id="pageRoot" class="blind">
    <span class="pageInstruction" style="left: 30px; top: 55px;">
      <p>Escucha el nombre de cada animal.</p>
    </span>
    <span class="pageInstruction" style="left: 30px; top: 95px;">
      <p>Marca cada sílaba con un aplauso.</p>
    </span>
    <span class="pageInstruction" style="left: 30px; top: 135px;">
      <p>Tacha el animal que tiene menos sílabas.</p>
    </span>

    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Araña" 
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"
        />
      <span class="checkmark" style="margin-left: 30px; margin-top: 270px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindvio/assets_p18/araña.svg">
      </span>
    </label>

    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Oso" 
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)" 
        :onload="loadOption('radios', 1, 2)"
        />
      <span class="checkmark" style="margin-left: 260px; margin-top: 270px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindvio/assets_p18/oso.svg">
      </span>
    </label>

    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Jirafa" 
        ref="1-3" 
        v-on:change="saveOption('radios', 1, 3)" 
        :onload="loadOption('radios', 1, 3)"
        />
      <span class="checkmark" style="margin-left: 30px; margin-top: 470px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindvio/assets_p18/jirafa.svg">
      </span>
    </label>

    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Chicharra" 
        ref="1-4" 
        v-on:change="saveOption('radios', 1, 4)" 
        :onload="loadOption('radios', 1, 4)"
        />
      <span class="checkmark" style="margin-left: 260px; margin-top: 470px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindvio/assets_p18/chicharra.svg">
      </span>
    </label>

  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 58px;
    top: 41px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>